(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('ConverterService', ConverterService);

    function ConverterService(){
        return {
            boolToInt : boolToInt
        };

        function boolToInt(boolValue){
            return boolValue ? 1 : 0;

    }

    };

})(angular);
